import React, { useEffect, useState } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { get, post } from 'aws-amplify/api'

import PsychologicalAssessmentContext from '../context/PsychologicalAssessmentContext'

const queryService = () => {
  const querystring = window.location.search
  const params = new URLSearchParams(querystring)

  return parseInt(params.get('serviceId')) || 1
}

const PsychologicalAssessmentProvider = ({ children }) => {
  const [currentView, setCurrentView] = useState(undefined)
  const [serviceId, setServiceId] = useState(queryService)
  const [countStepper, setCountStepper] = useState(0)
  const [tokenAuth, setTokenAuth] = useState('')

  const { getIdTokenClaims } = useAuth0()
  const baseUrl = process.env.REACT_APP_API_BASE_URL

  const getPsychologist = async (token) => {
    try {
      const resp = get({
        apiName: baseUrl,
        path: '/api/v2/psychologists/channeling',
        options: {
          headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${token.__raw}`
          }
        }
      })
      const { body } = await resp.response
      const data = await body.json()
      return data
    } catch (error) {
      console.log(error)
    }
  }

  const assignPsychologist = async (token, body) => {
    try {
      const resp = post({
        apiName: baseUrl,
        path: '/api/v2/psychologists/suggestions',
        options: {
          headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${token.__raw}`
          },
          body
        }
      })
      const { body: responseBody } = await resp.response
      const data = await responseBody.json()
      return data
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getIdTokenClaims()
      .then((resp) => {
        if (resp !== undefined) {
          setTokenAuth(resp)
        }
      })
      .catch((error) => console.log(error))
  }, [getIdTokenClaims])

  useEffect(() => {
    window.localStorage.removeItem('doctors')
  }, [])

  return (
    <PsychologicalAssessmentContext.Provider
      value={{
        serviceId,
        setServiceId,
        currentView,
        setCurrentView,
        countStepper,
        setCountStepper,
        getPsychologist,
        assignPsychologist,
        tokenAuth
      }}
    >
      {children}
    </PsychologicalAssessmentContext.Provider>
  )
}

export default PsychologicalAssessmentProvider
